// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"86":"3e5f7939","335":"6376d4bc","826":"6376d4bc"}[chunkId] + ".chunk.css";
};